export default {
      id: "arrow_bis-usage",
      viewBox: "0 0 16.5 11.2",
      url: __webpack_public_path__ + "svg/sprite.svg#arrow_bis",
      toString: function () {
        return this.url;
      }
    }